// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2C1_H","large":"styles_large__2sWW-"};